import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonHelper } from 'src/app/helper/helper.component';
import { CommonConstants } from 'src/app/shared/constants';
import { MasterService } from '../../master/services/master-service';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-state-wise-reports',
  templateUrl: './state-wise-reports.component.html',
  styleUrls: ['./state-wise-reports.component.scss'],
  providers: [MasterService, DatePipe, CommonHelper]
})
export class StateWiseReportsComponent implements OnInit {

  filterForm: FormGroup;
  emptyDataCheck: boolean = false;
  statesData: any;
  errorOrResponse = false;
  districtsData: any;
  reportsDistrictData: any;
  submitted: boolean = false;
  dataTable: any;
  showPickerStart = false;
  startDateTime: any = '';
  maxDate = new Date();
  showDateStart = true;
  showTimeStart = false;
  closeButtonStart: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };
  showPickerEnd = false;
  endDateTime: any = '';
  showDateEnd = true;
  showTimeEnd = false;
  language: any;
  closeButtonEnd: any = { show: true, label: 'Close Me!', cssClass: 'btn btn-sm btn-primary' };

  constructor(private spinner: NgxSpinnerService,
    private masterService: MasterService,
    private fb: FormBuilder,
    private datepipe: DatePipe,
    private chRef: ChangeDetectorRef,
    private commonHelper: CommonHelper) {
    // this.endDateTime = this.datepipe.transform(new Date(), "yyyy-MM-dd");
    // this.startDateTime = this.datepipe.transform(new Date(), "yyyy-MM-dd");
  }

  ngOnInit() {
    this.language = localStorage.getItem('language');
    this.getStates();
    this.filterDefaultValues();
    this.getReports(this.language)
    this.reportsDistrictData = [];
    this.emptyDataCheck = false;

  }

  // validation for forms
  filterDefaultValues() {
    this.filterForm = this.fb.group({
      selectedState: [],
      startDateTime: [''],
      endDateTime: [''],
    });
  }

  // toggle function to show datetime picker modal
  onTogglePicker(value) {
    if (value == 'startDT') {
      if (this.showPickerStart === false) {
        this.showPickerStart = true;

      }
    }
    if (value == 'endDT') {
      if (this.showPickerEnd === false) {
        this.showPickerEnd = true;
      }
    }
  }


  downLoadExcelReport() {
    try {
      this.spinner.show();
      this.masterService.getAll('export-report?state=true').subscribe((response: any) => {
        if (response) {
          window.open(response.data, '_blank');
          this.spinner.hide();

        } else {
          this.spinner.hide();

        }
      })
    } catch (error) {
      this.spinner.hide();
    }
  }
  // function to append value in input 
  onValueChange(val, endorstart) {
    if (endorstart == 'startDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd")
      this.startDateTime = val;
      this.submitted = false;
    }
    if (endorstart == 'endDT') {
      val = this.datepipe.transform(val, "yyyy-MM-dd")
      this.endDateTime = val;
      this.submitted = false;
    }
  }
  /** getStates
   * 
   * @param isStates 
   */
  getStates() {
    try {
      this.spinner.show();
      this.errorOrResponse = false;
      this.masterService.getAll('active_states').subscribe((response: any) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            this.spinner.hide();
            this.statesData = response.data;
            this.errorOrResponse = true;
          } else {
            this.spinner.hide();
            this.errorOrResponse = true;
          }
        }
      }, error => {
        this.spinner.hide();
        this.errorOrResponse = true;
      });
    } catch (excp) {
      this.spinner.hide();
    }
    setTimeout(() => {
      this.spinner.hide();
      if (this.errorOrResponse == false) {
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, 40000)
  }

  getReports(param: string) {
    if (!this.startDateTime && !this.endDateTime) {
      this.startDateTime = '';
      this.endDateTime = '';
    }
    this.apiCallForPostData("reports/complaints/summary?state=true&start_date=" + this.startDateTime + "&end_date=" + this.endDateTime, '', param);
  }

  /**
   * 
   * @param url 
   * @param data 
   */
  apiCallForPostData(url: string, data: any, param: string) {
    this.spinner.show();
    this.errorOrResponse = false;
    this.masterService.postData(url, data).subscribe((response: any) => {
      if (response.status == 200) {
        if (response.data.length > 0) {
          this.spinner.hide();
          this.postDataBinding(response, param);


          this.errorOrResponse = true;
        } else {
          this.reportsDistrictData = [];
          this.errorOrResponse = true;
          this.spinner.hide();
          this.commonHelper.toasterMessageError(CommonConstants.noResultFound);
          this.emptyDataCheck = false;
        }

      } else {
        this.errorOrResponse = true;
        this.emptyDataCheck = false;
        this.spinner.hide();
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage)
      }
    }, error => {
      this.reportsDistrictData = [];
      this.errorOrResponse = true;
      this.emptyDataCheck = false;
      this.spinner.hide();
    });
    setTimeout(() => {
      this.spinner.hide();
      if (this.errorOrResponse == false) {
        this.commonHelper.toasterMessageError(CommonConstants.validationMessage);
      }
    }, 400)
  }


  languageChange(event: any) {
    let apiUrl: 'state-wise/grievance-list';
    this.language = event
    localStorage.setItem('language', this.language);
    this.getReports(this.language);
  }

  postDataBinding(response: any, param: string) {
    let newResponse = [];
    this.errorOrResponse = true;
    this.emptyDataCheck = true;
    if (response.data.length > 0) {
      newResponse = response.data;
      if (param === 'isExcel') {
        this.reportData(newResponse, param);
      }
      //  else if (param === 'isPdf') {
      //   this.reportData(newResponse, param);
      // }
      else {
        this.reportsDistrictData = newResponse;
        const table: any = $("#dataTable1");
        this.reploatingDataTable();
        this.chRef.detectChanges();
        if (this.language == 'en') {
          this.dataTable = table.DataTable(
            { "order": [[1, "desc"]] },
            {
              language: {
                "emptyTable": "No data available in table",
                "info": "Showing _START_ to _END_ of _TOTAL_ entries",
                "infoEmpty": "Showing 0 to 0 of 0 entries",
                "infoFiltered": "(filtered from _MAX_ total entries)",
                "lengthMenu": "Show _MENU_ entries",
                "loadingRecords": "Loading...",
                "processing": "Processing...",
                "search": "Search:",
                "zeroRecords": "No matching records found",
                "paginate": {
                  "first": "First",
                  "last": "Last",
                  "next": "Next",
                  "previous": "Previous"
                },
                "aria": {
                  "sortAscending": ": activate to sort column ascending",
                  "sortDescending": ": activate to sort column descending"
                }
              }
            }
          ).draw();
        } else {
          this.dataTable = table.DataTable(

            {
              language: {
                "emptyTable": "तालिका में कोई डेटा उपलब्ध नहीं है",
                "info": "कुल _TOTAL_ एंट्रीज़ में से _START_ से _END_ तक दिखा रहे हैं",
                "infoEmpty": "कुल 0 एंट्रीज़ में से 0 से 0 तक दिखा रहे हैं",
                "infoFiltered": "(_MAX_ एंट्रीज़ से फ़िल्टर किए गए)",
                "lengthMenu": "_MENU_ एंट्रीज़ दिखाएं",
                "loadingRecords": "लोड हो रहा है...",
                "processing": "प्रसंस्करण...",
                "search": "खोजें:",
                "zeroRecords": "कोई मिलान नहीं मिला",
                "paginate": {
                  "first": "पहला",
                  "last": "अंतिम",
                  "next": "अगला",
                  "previous": "पिछला"
                },
                "aria": {
                  "sortAscending": ": आरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें",
                  "sortDescending": ": अवरोही क्रम में कॉलम को क्रमित करने के लिए सक्रिय करें"
                }
              }
            })
        }

      }
    } else {
      this.reportsDistrictData = [];
      this.emptyDataCheck = false;
      this.errorOrResponse = true;
      this.reploatingDataTable();
      const table: any = $("#dataTable1");
      this.dataTable = table.DataTable().draw();
      this.commonHelper.toasterMessageError(CommonConstants.noResultFound);
    }
  }

  /*redraw the datatable*/
  reploatingDataTable() {
    let table = $("#dataTable1").DataTable();
    table.destroy();
  }

  /**
   * 
   * @param rData 
   * @param param 
   */
  reportData(rData: any, param: any) {
    let data = [];
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
    };

  }


  /**
   * 
   * @param data 
   */
  exportToPdf(data: any) {
    let doc = new jsPDF('p', 'pt'),
      col = ["Sr. No.", "District Name", "Grievance Raised", "Grievance Pending", "Grievance Resolved", "Resolved Percent(%)"],
      rows = [];
    var header = function (data) {
      doc.setFontSize(16);
      doc.setTextColor(40);
      doc.setFontStyle('normal');
      doc.text("District Wise Report", 220, 20);
    };
    data.filter((element: any, index: number) => {
      let temp = [index + 1, element.name, element.complaintRaised, element.complaintPending, element.complaintResolved, element.resolvedPercent];
      rows.push(temp);
    });

    doc.autoTable(col, rows, {
      theme: 'grid',
      startY: 32,
      addPageContent: header,
      styles: {
        cellPadding: 0.5,
        fontSize: 8
      },
      drawCell: function (cell: any, data: any) {
        if (data.column.dataKey === 'price' || data.column.dataKey === 'qty' || data.column.dataKey === 'price') {
          cell.styles.halign = 'right';
        }
      }
    });
    doc.save(CommonConstants.districtWiseReport + '.pdf');
  }

  /**
   * 
   */
  downloadExcel() {
    this.getReports('isExcel');
  }

  downloadPdf() {
    this.getReports('isPdf')
  }

  submitReport() {
    let sDate = this.datepipe.transform(this.startDateTime, "yyyy-MM-dd"),
      eDate = this.datepipe.transform(this.endDateTime, "yyyy-MM-dd");
    if (sDate) {
      if (eDate) {
        if (sDate >= eDate) {
          this.submitted = true;
          this.emptyDataCheck = false;
        } else {
          this.submitted = false;
          this.getReports('');
        }
      } else {
        this.submitted = false;
        this.getReports('')
      }
    } else {
      this.submitted = false;
      this.getReports('')
    }
  }

  clear() {
    this.filterForm.reset();
    this.startDateTime = '';
    this.endDateTime = '';
  }
}
